module.exports = __webpack_public_path__ + "static/media/catalouge-03.1d9a66ba.jpg";